<template>
<div>
    <el-row :gutter="10">
        <el-col :span="24">
            <div class="fr">
                <el-checkbox v-model='dataForm.lastFlag' :true-label=1 :false-label=0 v-if="!viewFlag">最终报价</el-checkbox>
                <span v-else>{{dataForm.lastFlag ? "最终报价" : "中途报价"}}</span>
            </div>
            <el-table :data="partList" row-key="id" size="small" border :header-cell-style="{background:'#f5f5f5'}" style="width: 100%;" class="mb15" :default-expand-all="false">
                <el-table-column type="index" label="序号" fixed>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false">
                </el-table-column>
                <el-table-column prop="supplierId" label="supplierId" v-if="false">
                </el-table-column>
                <el-table-column prop="roundNo" label="roundNo" v-if="false">
                </el-table-column>
                <el-table-column prop="rfqPartId" label="rfqPartId" v-if="false">
                </el-table-column>
                <el-table-column prop="partCode" header-align="center" align="left" label="零件编号" width="150" fixed>
                </el-table-column>
                <el-table-column prop="partName" header-align="center" align="left" label="零件名称" width="150" fixed>
                </el-table-column>
                <el-table-column prop="salePriceCost" header-align="center" align="right" label="销售价格" width="110" fixed>
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.salePriceCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="taxCost" header-align="center" align="right" label="增值税" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.taxCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="totalCost" header-align="center" align="right" label="总计(O=M+N)[不含税]" width="180">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.totalCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="feeCostSum" header-align="center" align="right" label="合计(M=J+K+L)" width="150">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.feeCostSum)}}
                    </template>
                </el-table-column>
                <el-table-column prop="productUnitPrice" header-align="center" align="right" label="产品单价(J=D+H+I)" width="150">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.productUnitPrice)}}
                    </template>
                </el-table-column>
                <!-- 目标价格需要隐藏 -->
                <!-- <el-table-column v-if="userInfo.typeId !== USER_TYPE.SUPPLIER" prop="targetPrice" header-align="left" align="left" label="目标价格">
                    </el-table-column> -->
                <el-table-column prop="materialCost" header-align="center" align="right" label="原材料(A)" width="150">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.materialCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="outsidePartCost" header-align="center" align="right" label="外购零部件(B)" width="150">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.outsidePartCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="processingCost" header-align="center" align="right" label="加工费(C)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.processingCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="managementCost" header-align="center" align="right" label="管理费用(E)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.managementCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="saleCost" header-align="center" align="right" label="销售费用(F)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.saleCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="accountCost" header-align="center" align="right" label="财务费用(G)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.accountCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="profit" header-align="center" align="right" label="利润(I)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.profit)}}
                    </template>
                </el-table-column>
                <el-table-column prop="packageFee" header-align="center" align="right" label="包装费(K)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.packageFee)}}
                    </template>
                </el-table-column>
                <el-table-column prop="transportFee" header-align="center" align="right" label="运输费(L)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.transportFee)}}
                    </template>
                </el-table-column>
                <el-table-column prop="totalInvest" header-align="center" align="right" label="总投资额" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.totalInvest)}}
                    </template>
                </el-table-column>
                <el-table-column prop="amortizationMoney" header-align="center" align="right" label="分摊(N)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.amortizationMoney)}}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" v-if="!viewFlag" header-align="center" align="left" min-width="150" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="showHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            零件报价
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" v-else header-align="center" align="left" min-width="80" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="showHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-col>
    </el-row>
    <!-- 弹窗, 新增 / 修改 -->
    <addOrUpdate v-if="addOrUpdateQuotedPriceVisibe" ref="addOrUpdate" @refreshDataList="getAppartmentList"></addOrUpdate>
</div>
</template>

<script>
import {
    RFQ_STATUS,
} from '@/utils/const'
import {
    getRfqPartsByVenderId
} from '@/controller/quotation'
import AddOrUpdate from './quotation-part-add-or-update'
import FileUpDown from "@/views/common/file-up-down";
export default {
    components: {
        AddOrUpdate,
        FileUpDown
    },
    props: {
        vender: Object,
        dataForm: Object
    },
    data() {
        return {
            viewFlag: false,
            roundNo: 0,
            addOrUpdateQuotedPriceVisibe: false,
            RFQ_STATUS: RFQ_STATUS,
            rfqId: '',
            partList: [],
        }
    },
    mounted() {},
    methods: {
        // 查所有询价零件
        getAppartmentList(viewFlag, roundNo, rfqId) {
            this.viewFlag = viewFlag
            this.roundNo = roundNo
            this.rfqId = rfqId? rfqId : this.dataForm.id
            getRfqPartsByVenderId({
                id: this.rfqId,
                venderId: this.vender.id
            }).then((data) => {
                if (data && data.code === "00") {
                    this.partList = data.body;
                } else {
                    this.partList = [];
                }
            });
        },
        // 新增 / 修改 报价
        addOrUpdateHandle(row) {
            this.addOrUpdateQuotedPriceVisibe = true;
            row.rfqId = this.rfqId
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, this.vender, 'edit', this.roundNo);
            });
        },
        showHandle(row) {
            this.addOrUpdateQuotedPriceVisibe = true;
            row.rfqId = this.rfqId
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, this.vender, 'view', this.roundNo);
            });
        },
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            console.log(val)
            return Number(Number(val).toFixed(3))
        },
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}

.button-danger {
    color: #F56C6C
}

.mb15 {
    margin-bottom: 15px;
}
</style>
